import { Type } from "class-transformer";
import { ObjectView } from "./objects/object";
import { OBJECT_REGISTRY } from "./utils/object-registry";
import { GroupView } from "./objects/group";

export class Layer{
    visible:boolean;
    name:string;
    @Type(() => ObjectView, {
        discriminator: {
          property: '__type',
          subTypes: [
            ...Object.entries(OBJECT_REGISTRY).map(([name, value]) => ({
              value,
              name
            })),
            { value: GroupView, name: 'group' }
          ]
        }
      })
      objects: ObjectView[];
}